 
<template>
  <div class="company-content">
    <companyCard :companyItem="company" />
  </div>
</template>

<script>
import companyCard from "./CompanyCard";
import axios from "axios";
export default {
  components: {
    companyCard,
  },
  data() {
    return {
      company: {},
    };
  },
  methods: {
    reqCompany() {
      axios.get("./data.json").then((res) => {
        this.company = res.data.longzhichao;
      });
    },
  },
  mounted() {
    this.reqCompany();
  },
};
</script>

